import * as ReactGA from 'react-ga';

let useGa = false;

export const sendPageView = () => {
	if (!useGa) {
		return;
	}

	ReactGA.pageview(window.location.pathname + window.location.search);
};

export const sendVirtualPageView = (page: string) => {
	if (!useGa) {
		return;
	}

	ReactGA.pageview(page);
};

export const startGoogleAnalytics = () => {
	useGa = true;
	ReactGA.initialize('UA-36863627-9');
};
